module.exports = __webpack_public_path__ + "img/car.343983c.svg";